<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[410px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-auto">
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px]"
          >
            <div class="w-full flex flex-col items-center">
              <WorkFlowChartIcon class="w-[50px] h-[50px] text-primary" />
              <span class="PC_Body1-SB !text-[#1F1D1F]">
                จัดหน้าที่ภายในศูนย์
              </span>
            </div>
            <SelectBoxComponent
              :inputId="'formShelterPositionId'"
              :keyValue="'id'"
              :keyName="'name'"
              :options="AllShelterPosition"
              :value="form.shelter_position_id"
              :label="'หน้าที่ภายในศูนย์'"
              :placeholder="'เลือกตำแหน่งหน้าที่ภายในศูนย์'"
              :warningMessage="errors.shelter_position_id"
              :hideValues="[form.hideShelter_position_id]"
              @update:modelValue="
                (res) => {
                  form.shelter_position_id = res;
                }
              "
            />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--save'"
                :disabled="form.shelter_position_id == ''"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script setup>
import { ref } from "vue";
import { useGlobals } from "../../components/Utilities/javascripts/useGlobals";
import { useShelterStore } from "@/pinia/shelter";
import { storeToRefs } from "pinia";

const { $validateMsg } = useGlobals();
const shelterStore = useShelterStore();
const { AllShelterPosition } = storeToRefs(shelterStore);
const input = {
  id: "",
  shelter_position_id: "",
  hideShelter_position_id: "", // ใช้ซ่อน shelter_position_id ปัจจุบัน
};
const form = ref({ ...input });
const errors = ref({ ...input });
const modalIsOpened = ref(false);

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  console.log("data", data);
  form.value = {
    ...input,
  };
  errors.value = {
    ...input,
  };
  if (data) {
    form.value.id = data.id;
    // form.value.shelter_position_id = data.shelter_position_id;
    form.value.hideShelter_position_id = data.shelter_position_id;
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const emit = defineEmits(["status"]);

const save = async () => {
  await shelterStore
    .assignPositionToStaff(form.value.id, form.value)
    .then((response) => {
      if (response.status === 200) {
        if (response.data.is_warning == true) {
          emit(
            "status",
            response.data.message,
            "warning",
            form.value.id,
            form.value
          );
          closeModal();
        } else {
          emit("status", response.data.message, "success");
          closeModal();
        }
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style scoped>
</style>